import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 25000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("qr_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/**
 * One transparent retry on network failures / 502-504 gateway errors.
 * Preview environments can briefly return a Cloudflare "bad gateway"
 * during warm-up; this makes user-facing forms resilient to those blips.
 */
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const status = error.response?.status;
    const isNetwork = !error.response;
    const isGateway = status === 502 || status === 503 || status === 504;
    if ((isNetwork || isGateway) && !cfg.__retried) {
      cfg.__retried = true;
      await new Promise((r) => setTimeout(r, 1200));
      return api.request(cfg);
    }
    return Promise.reject(error);
  }
);

export const getToken = () => localStorage.getItem("qr_admin_token");
export const setToken = (t) => localStorage.setItem("qr_admin_token", t);
export const clearToken = () => localStorage.removeItem("qr_admin_token");
